module.exports = __webpack_public_path__ + "static/media/ppt.68dc6189.svg";